import CartRepository from "../../../repository/CartRepository";
import * as React from "react";
import getSymbolFromCurrency from 'currency-symbol-map'
import { isArray, isObject, isString } from "underscore";
import Helper from "src/support/Helper";
import ProductPricingRepository from "../../../repository/ProductPricingRepository";
import { SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT } from "../../../store/slice/model/Cart";
import store from "../../../storeWire";
import AxiosIndicatorRunTimeLoader from "../../AxiosIndicatorRunTimeLoader";

class Common {
    getDisplayStatusOfContactUsButton = (disable_add_to_quote = false, single_product_inventory, single_product, single_product_pricing_list) => {
        // DT - 31/march CR - 9654 - EOL part hide contact us button
        if (single_product?.EndOfLifeFlag === true) {
            return false;
        }
        if (this.getDisplayStatusOfAddToQuote(disable_add_to_quote, single_product_inventory, single_product, single_product_pricing_list) === false &&
            this.getDisplayStatusOfAddToCart(single_product_pricing_list, single_product, single_product_inventory) === false) {
            return true;
        }
        if (this.getDisplayStatusOfInventory(single_product, single_product_inventory, single_product_pricing_list)) {
            return true;
        }
        return false;
    }
    getDisplayStatusOfInventory = (single_product, single_product_inventory, single_product_pricing_list) => {
        if (single_product.ObsoleteFlag === true) {
            // Check If Inventory is Out Of Stock
            if (single_product_inventory && single_product_inventory.quantity !== undefined && single_product_inventory.quantity < 1) {
                return true;
            }
            if (single_product_inventory && single_product_inventory.qas && single_product_inventory.qas < 1) { // 13141
                return true;
            }
            // Check Pricing
            if (single_product_pricing_list === undefined || single_product_pricing_list === null ||
                (single_product_pricing_list !== null && single_product_pricing_list.length < 1)) {
                return true;
            }
        }
        return false;
    }
    getDisplayStatusOfAddToCart = (single_product_pricing_list, single_product, single_product_inventory) => {
        let status = null;
        if (single_product_pricing_list === undefined) {
            status = false;
        }
        if (single_product_pricing_list !== undefined && single_product_pricing_list.length < 1) {
            status = false;
        }
        if (single_product === undefined) {
            status = false;
        }
        if (status === null &&
            single_product_inventory &&
            single_product_inventory.quantity !== undefined &&
            single_product_inventory.quantity > 0 &&
            single_product.ObsoleteFlag === true &&
            single_product.EndOfLifeOFlag === false
        ) {
            status = true;
        }
        if (status === null &&
            single_product.ObsoleteFlag === false &&
            single_product.EndOfLifeOFlag === true
        ) {
            if (single_product_inventory && single_product_inventory.quantity !== undefined) {
                status = true;
            }
        }

        if (status === null &&
            single_product.ObsoleteFlag === false &&
            single_product.EndOfLifeOFlag === false
        ) {
            status = true;
        }
        //Make it last only
        if (status === null) {
            status = false;
        }
        return status;
    }
    getDisplayStatusOfAddToQuote = (disable_add_to_quote = false, single_product_inventory, single_product, single_product_pricing_list) => {
        if (disable_add_to_quote !== undefined && disable_add_to_quote === true) {
            return false;
        }
        if (single_product_inventory && single_product_inventory.quantity !== undefined && single_product_inventory.quantity < 1 &&
            single_product.ObsoleteFlag === true && single_product.EndOfLifeOFlag === false &&
            single_product_pricing_list !== undefined && single_product_pricing_list.length > 0
        ) {
            return false;
        }

        // Having Obsolete & Inventory & Pricing
        if (single_product_inventory && single_product_inventory.quantity !== undefined && single_product_inventory.quantity > 1 &&
            single_product.ObsoleteFlag === true && single_product.EndOfLifeOFlag === false &&
            single_product_pricing_list !== undefined && single_product_pricing_list.length > 0
        ) {
            return false;
        }

        // With Obsolete flag and pricing / inventory missing
        if (single_product.ObsoleteFlag === true &&
            ((single_product_inventory && single_product_inventory.quantity !== undefined && single_product_inventory.quantity < 1) ||
                (single_product_pricing_list !== undefined && single_product_pricing_list.length === 0) || (single_product_pricing_list === undefined))) {
            return false;
        }
        if (single_product_pricing_list !== undefined && single_product_pricing_list.length < 1) {
            return true;
        }
        if (single_product_pricing_list === undefined) {
            return true;
        }
        return true;
    }
    getPriceLineClass = (isPLP, priceArray, rowIndex, linesToDisplay) => {
        if (isPLP !== undefined && isPLP === true) {
            return (rowIndex == 0 || rowIndex === (priceArray.length - 1)) ? '' : 'none'
        }
        return (rowIndex + 1) > linesToDisplay ? 'none' : ''
    };
    getObsoleteFailedFlag = (single_product, QuantityAddToCart, single_product_inventory) => {
        if (single_product !== undefined &&
            single_product &&
            single_product.ObsoleteFlag !== undefined &&
            single_product.ObsoleteFlag === true &&
            single_product_inventory.quantity !== undefined &&
            single_product_inventory.quantity > 0 &&
            QuantityAddToCart > single_product_inventory.quantity) {
            return true;
        }
        return false;
    };
    getEndOfLifeOFlagFailedFlag = (single_product, QuantityAddToCart, single_product_inventory) => {
        if (single_product !== undefined &&
            single_product &&
            single_product.EndOfLifeOFlag !== undefined &&
            single_product.EndOfLifeOFlag === true &&
            single_product_inventory.quantity !== undefined &&
            single_product_inventory.quantity > 0 &&
            QuantityAddToCart > single_product_inventory.quantity) {
            return true;
        }
        return false;
    };
    getQuantityAddToCart = (single_product, CART_BEFORE_TO_SEND_SERVER) => {
        //single_product can be ERPPartNumberWithContract
        //always check single_product is object or not.
        let q = this.getObjectOfAddToCart(single_product, CART_BEFORE_TO_SEND_SERVER);
        if (q.quantityAddToCart !== undefined) {
            return q.quantityAddToCart;
        }
        return 0;
    };
    singleProductToERPPartNumber = (single_product) => {
        let ERPPartNumber;
        if (isObject(single_product) &&
            single_product !== undefined &&
            single_product.ERPPartNumber !== undefined
        ) {
            ERPPartNumber = single_product.ERPPartNumber;
        }
        if (isString(single_product)) {
            ERPPartNumber = single_product;
        }
        return ERPPartNumber;
    }
    getObjectOfAddToCart = (single_product, CART_BEFORE_TO_SEND_SERVER) => {
        if (CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]) {
            return CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber];
        }
        return false;
    };
    getQuantityUpdateToCart = (single_product, CART_DATA_OBJECT) => {
        return new CartRepository().getQuantityByItemNumber(single_product.ItemNumber, CART_DATA_OBJECT);
    };
    getObjectOfUpdateToCart = (single_product, CART_DATA_OBJECT) => {
        if (single_product !== undefined &&
            single_product.ERPPartNumber !== undefined &&
            CART_DATA_OBJECT[single_product.ERPPartNumber] !== undefined
        ) {
            return CART_DATA_OBJECT[single_product.ERPPartNumber];
        }
        return false;
    };
    getDisplayStatusOfPricingTable = (single_product_inventory, single_product) => {
        if (!single_product_inventory ||
            (single_product_inventory.quantity !== undefined && single_product_inventory.quantity < 1)
            &&
            (single_product.ObsoleteFlag === true)) {
            return false;
        }
        return true;
    };
    getClass = (single_price, current_index, single_product_pricing_list, QuantityToCart, getClassString = true) => {
        let d = false;
        if (current_index === this.getCurrentPriceMatchIndex(single_price, current_index, single_product_pricing_list, QuantityToCart)) {
            d = true;
        }
        if (getClassString) {
            return d ? 'font-bold' : ' ';
        } else {
            return d;
        }
    };
    getClassForFarnellInventory = (single_price, current_index, single_product_pricing_list, QuantityToCart, getClassString = true) => {
        let d = false;
        if (current_index === this.getCurrentPriceMatchIndexForFarnellInventory(single_price, current_index, single_product_pricing_list, QuantityToCart)) {
            d = true;
        }
        if (getClassString) {
            return d ? 'font-bold' : ' ';
        } else {
            return d;
        }
    };
    setPricingAutomaticallyBasedOnPricing = async (quantity, single_product_pricing_list, single_product) => {
        if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0 && single_product.ItemNumber) {
            let unitPriceAlreadySet = await new ProductPricingRepository().getPricingFromCartPriceBeforeSendToServerByERPPartNumber(single_product.ItemNumber);
            if (unitPriceAlreadySet === false) {
                let marketPrice;
                try {
                    marketPrice = this.getCurrentPriceByQuantityAndPriceArray(single_product_pricing_list, quantity).marketPrice
                } catch (e) {
                }
                await store.dispatch(SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
                    CART_DATA: {
                        unitPrice: marketPrice,
                        ItemNumber: single_product.ItemNumber
                    }
                }));
            }
        }
    };
    getCurrentPriceMatchIndex = (current_value, current_index, single_product_pricing_list, QuantityToCart) => {
        let p_c = 0;
        let p_n = 0;
        let last = single_product_pricing_list[Object.keys(single_product_pricing_list).pop()];
        if (last && last.demandQuantityOut !== undefined) {
            if (QuantityToCart >= last.demandQuantityOut) {
                QuantityToCart = last.demandQuantityOut;
            }
        }
        let next_index = current_index + 1;
        if (current_value && current_value.demandQuantityOut !== undefined) {
            p_c = current_value.demandQuantityOut;
        }
        let next_value = single_product_pricing_list[next_index];
        if (next_value && next_value.demandQuantityOut !== undefined) {
            p_n = next_value.demandQuantityOut;
        }
        let decision = false;
        if (current_index === 0
            &&
            QuantityToCart <= p_c
        ) {
            decision = true;
        }
        if (QuantityToCart > p_c && QuantityToCart < p_n) {
            decision = true;
        }
        if (QuantityToCart === p_c) {
            decision = true;
        }
        if (decision) {
            return current_index;
        } else {
            return false;
        }
    };
    getCurrentPriceByQuantityAndPriceArray = (single_product_pricing_list, QuantityToCart) => {
        let current_value_final = false;
        if (single_product_pricing_list !== undefined && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
            let last = single_product_pricing_list[Object.keys(single_product_pricing_list).pop()];
            if (last && last.demandQuantityOut !== undefined) {
                if (QuantityToCart >= last.demandQuantityOut) {
                    QuantityToCart = last.demandQuantityOut;
                }
            }
            single_product_pricing_list.map((current_value, current_index) => {
                if (current_value_final) {
                    return;
                }
                let p_c = 0;
                let p_n = 0;
                let next_index = current_index + 1;
                if (current_value && current_value.demandQuantityOut !== undefined) {
                    p_c = current_value.demandQuantityOut;
                }
                let next_value = single_product_pricing_list[next_index];
                if (next_value && next_value.demandQuantityOut !== undefined) {
                    p_n = next_value.demandQuantityOut;
                }
                let decision = false;
                if (current_index === 0
                    &&
                    QuantityToCart <= p_c
                ) {
                    decision = true;
                }
                if (QuantityToCart > p_c && QuantityToCart < p_n) {
                    decision = true;
                }
                if (QuantityToCart === p_c) {
                    decision = true;
                }
                if (decision) {
                    current_value_final = current_value;
                } else {
                    return false;
                }
            });
        }
        if (current_value_final === false) {
            current_value_final = 0;
        }
        return current_value_final;
    };
    template_for_pricing = (single_product_pricing_list, single_product_pricing_list_length, getClassFROMUI, linesToDisplay = 100, isPLP = false, visibility = true, CPN_PRICING_ACTIVATED = false, endOfLifeBackFlag = true, hiddenPriceTableMode) => {
        //visibility will be mainly used by loader so please take decision based on that
        let option_style = {
            visibility: visibility ? 'visible' : 'hidden'
        };
        const getPriceStyle = (demandQuantityOut) => {
            if (demandQuantityOut === undefined || demandQuantityOut === null || isNaN(demandQuantityOut) || Number(demandQuantityOut) <= 0) {
                return 'hidden';
            }
            if (visibility === false) {
                return 'hidden';
            }

            if (hiddenPriceTableMode == true) {
                return 'hidden';
            }
            return 'visible'
        };
        const getDemandQty = (demandQtyOut) => {
            /***
             * Author: Trilok
             * Date: 17/02/2023
             * Reason: do not display qty  when signgle CPN is present
             */
            if (CPN_PRICING_ACTIVATED === true && single_product_pricing_list !== undefined && single_product_pricing_list !== null && single_product_pricing_list_length === 1) {
                return null;
            }
            return demandQtyOut + "+";
        }
        return (
            <>
                {CPN_PRICING_ACTIVATED === true &&
                    <div style={option_style} className="blue-head cpn-box">
                        <span className="text-nowrap">Customer Specific Pricing</span>
                        <span className="fa fa-handshake-o" />
                    </div>
                }
                {single_product_pricing_list !== undefined &&
                    single_product_pricing_list_length > 0 &&
                    endOfLifeBackFlag === true &&
                    hiddenPriceTableMode !== true &&
                    <div className="price-table-list">
                        {visibility === false &&
                            <div className="d-flex justify-content-center">
                                <AxiosIndicatorRunTimeLoader inline={true} />
                            </div>
                        }
                        {single_product_pricing_list.map((v, i) => (
                            <div className={'bs5 row mx-0 ' + getClassFROMUI(v, i)} key={i} style={
                                {
                                    ...option_style,
                                    display: this.getPriceLineClass(isPLP, single_product_pricing_list, i, linesToDisplay),
                                }
                            }>
                                <div className="ps-0 col-6 font-12"
                                    style={{ visibility: getPriceStyle(v.demandQuantityOut) }}>
                                    <span>{getDemandQty(v.demandQuantityOut)}</span></div>
                                <div className="pe-0 col-6 text-end font-12">
                                    <span>{Helper.getFormatNumber(Number(v.marketPrice), window.mct, window.mcs, 5)}</span>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                }
            </>
        );
    };

    template_for_add_part_pricing = (single_product_pricing_list) => {
        return (
            <>
                {single_product_pricing_list &&
                    <div className="price-table-list price-table-list-with-border w130">
                        {
                            isObject(single_product_pricing_list) &&
                            /**
                             * Use directly first price object because display only one 
                             */
                            <div className='bs5 row mx-0'>
                                <div className="ps-0 col-6 font-12"><span>{single_product_pricing_list[0].demandQuantityOut}+</span></div>
                                <div className="pe-0 col-6 text-end font-12">
                                    <span>{getSymbolFromCurrency(single_product_pricing_list[0].currency)}{single_product_pricing_list[0].marketPrice}</span></div>
                            </div>
                        }
                    </div>
                }
            </>
        )
    };

    static isCpnIsManual = (single_product, selectedCPN) => {
        if (single_product?.CustomerPartNumbers?.length > 0 && Helper.valueIsNotNull(selectedCPN)) {
            if (single_product?.CustomerPartNumbers.filter(e => e.CPN.toLowerCase() === selectedCPN.toLowerCase()).length > 0) {
                return false;
            }
        }
        return true;
    }

    static getMinQtyAndPrice = (productPriceList) => {
        return productPriceList[0]
    }

    getCurrentPriceMatchIndexForFarnellInventory = (current_value, current_index, single_product_pricing_list, QuantityToCart) => {
        let p_c = 0;
        let p_n = 0;
        let last = single_product_pricing_list[Object.keys(single_product_pricing_list).pop()];
        if (last && last.From !== undefined) {
            if (QuantityToCart >= last.From) {
                QuantityToCart = last.From;
            }
        }
        let next_index = current_index + 1;
        if (current_value && current_value.From !== undefined) {
            p_c = current_value.From;
        }
        let next_value = single_product_pricing_list[next_index];
        if (next_value && next_value.From !== undefined) {
            p_n = next_value.From;
        }
        let decision = false;
        if (current_index === 0
            &&
            QuantityToCart <= p_c
        ) {
            decision = true;
        }
        if (QuantityToCart > p_c && QuantityToCart < p_n) {
            decision = true;
        }
        if (QuantityToCart === p_c) {
            decision = true;
        }
        if (decision) {
            return current_index;
        } else {
            return false;
        }
    };
}

export default Common;